import React, { useState } from 'react';
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, message, Upload } from 'antd';
import { uploadPrompt } from '@/api/promptUpload';

const PromptUploadPage: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const beforeUpload: UploadProps['beforeUpload'] = async (file) => {
    const isExcel =
      file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel';
    if (!isExcel) {
      message.error('只能上传 Excel 文件！');
      return Upload.LIST_IGNORE; // 阻止上传
    }

    try {
      setLoading(true);
      const response = await uploadPrompt(file as File);
      if (response.success) {
        message.success('上传成功');
      } else {
        message.error(response.message || '上传失败');
      }
    } catch (error) {
      console.error('上传错误:', error);
      message.error('上传过程中发生错误，请稍后再试');
    } finally {
      setLoading(false);
    }

    return Upload.LIST_IGNORE; // 阻止默认上传行为
  };

  return (
    <div>
      <span>上传提示词：</span>
      <Upload beforeUpload={beforeUpload}>
        <Button icon={loading ? <LoadingOutlined /> : <UploadOutlined />}>excel表单上传</Button>
      </Upload>
      {/* <div style={{ marginTop: '20px' }}>
        <Button style={{ marginRight: '20px' }} type="primary">
          推送
        </Button>
        <Button>取消</Button>
      </div> */}
    </div>
  );
};

export default PromptUploadPage;
